import { debug }     from './theme/debug.js';
import { helpers }   from './theme/helpers.js';
import { hamburger } from './theme/components/hamburger.js';
import { modal }     from './theme/components/modal.js';
import { sliders }     from './theme/components/sliders.js';
import { scrollTo }     from './theme/components/scrollTo.js';

window.theme = {
    globals: {
        enablePjax: true,
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },

    init: function() {
        var theme = this;

        hamburger.init();
        modal.init();
        sliders.init();
        scrollTo.init();

        $( document.body ).addClass( 'loaded' );

        if ( theme.globals.isTouch === true ) {
            $( document.body ).addClass( 'touch-device' );
        } else {
            $( document.body ).addClass( 'pointer-device' );
        }
    }
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );
